<template>
  <t-default-layout active-nav-id="home-sub-banner">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="HomeSubBanner" :show="show" />
      <form
        ref="form"
        class="t-home-sub-banner-detail__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-home-sub-banner-detail__fields">
          <m-section>
            <div class="t-home-sub-banner-detail__tabgroup">
              <ul class="t-home-sub-banner-detail__tabnav">
                <li
                  data-testid="new-home-sub-banner-display-button"
                  :class="{ selected: activeTab === 'new' }"
                  @click="activeTab = 'new'"
                >
                  リニューアル後（新小バナー）
                </li>
                <li
                  data-testid="old-home-sub-banner-display-button"
                  :class="{ selected: activeTab === 'old' }"
                  @click="activeTab = 'old'"
                >
                  リニューアル前（旧小バナー）
                </li>
              </ul>

              <!-- 詳細設定（新旧統合） -->
              <m-action-card
                :id="idName[1]"
                :test-id-text="detail-home-sub-banner"
                title="詳細設定"
                :document-id="id"
                header-border
                no-header-margin
                icon="clock"
              ><div class="t-home-sub-banner-add__row1">
                <m-form-input id="t-home-sub-banner-add-dAccountLoginFlag__form-input">
                  <a-text id="t-home-sub-banner-add-dAccountLoginFlag__a-text">ビジネスｄアカウントログイン</a-text>
                  <a-switch
                    id="t-home-sub-banner-add-dAccountLoginFlag"
                    v-model="homeSubBannerData.dAccountLoginFlag"
                    data-testid="add-me-sub-banner-priority-toggle-button"
                    :disabled="true"
                  />
                </m-form-input>
              </div>
              <div class="t-home-sub-banner-add__row1">
                <m-form-input id="t-home-sub-banner-add-webviewFlag__form-input">
                  <a-text id="t-home-sub-banner-add-webviewFlag__a-text">Webビュー</a-text>
                  <a-switch
                    id="t-home-sub-banner-add-webviewFlag"
                    v-model="homeSubBannerData.webviewFlag"
                    data-testid="add-me-sub-banner-priority-toggle-button"
                    :disabled="true"
                  />
                </m-form-input>
              </div>
                <div class="t-home-sub-banner-detail__row1">
                  <m-form-input
                    id="t-home-sub-banner-detail-notificationPromptFlag__form-input"
                    class="t-home-sub-banner-detail__flag-row"
                  >
                    <a-text
                      id="t-home-sub-banner-detail-notificationPromptFlag__a-text"
                      class="t-home-sub-banner-detail__label-with-indent"
                      weight="bold"
                      >通知許可フラグ</a-text
                    >
                    <div class="t-home-sub-banner-detail__flag-control">
                      <a-switch
                        id="t-home-sub-banner-detail-notificationPromptFlag"
                        v-model="homeSubBannerData.notificationPromptFlag"
                        class="t-home-sub-banner-detail__switch-label"
                        data-testid="detail-home-sub-banner-notificationPromptFlag"
                        :disabled="true"
                      />
                      <a-text id="t-home-sub-banner-detail-notificationPromptFlag__a-text-notice" class="t-home-sub-banner-detail__flag-control__notice">
                        ※プッシュ通知未許可ユーザーにポップアップを表示します
                      </a-text>
                    </div>
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-detail__fields"> <!-- 差分：画像・テキスト入力エリア -->
                  <div
                    v-show="activeTab === 'new'"
                    id="t-home-sub-banner-detail-uploading-file-new" class="t-home-sub-banner-detail__row t-home-sub-banner-detail__row--square"
                  >
                    <div class="t-home-sub-banner-detail__col-1">
                      <m-form-input>
                        <a-upload-field
                          id="t-home-sub-banner-detail-upload-newImage"
                          v-model="homeSubBannerData.newImageFile.file"
                          test-id-text="detail-home-sub-banner-image"
                          name="imageFile"
                          class="t-home-sub-banner-detail-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          :disabled="true"
                        />
                      </m-form-input>
                    </div>
                    <div class="t-home-sub-banner-detail__col-2">
                      <a-text class="t-home-sub-banner-detail__text-field-label" weight="bold">タイトル</a-text>
                      <m-form-input>
                        <a-apply-text-field
                        id="title-new"
                        v-model="homeSubBannerData.newTitle"
                        type="text"
                        maxlength="19"
                        placeholder="タイトル入力"
                        :disabled="true" />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-detail__text-field-label" weight="bold">補足説明</a-text>
                      <m-form-input>
                        <a-apply-text-field
                        id="description"
                        v-model="homeSubBannerData.newDescription"
                        type="text"
                        maxlength="22"
                        placeholder="補足説明入力"
                        :disabled="true" />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-detail__text-field-label" weight="bold">タグ設定</a-text>
                      <div class="t-home-sub-banner-detail__tag-list">
                        <div
                          v-for="(tag, index) in homeSubBannerData.newTags"
                          :key="index"
                          class="t-home-sub-banner-detail__tag-item"
                        >
                          <m-form-input>
                            <a-apply-text-field
                              :id="'tag-' + index"
                              v-model="homeSubBannerData.newTags[index]"
                              :data-testid="'detail-home-sub-banner-tag-display-new-' + index"
                              type="text"
                              maxlength="10"
                              :placeholder="'タグ' + (index + 1)"
                              :disabled="true" 
                            />
                          </m-form-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="activeTab === 'old'"
                    id="t-home-sub-banner-detail-uploading-file"
                    class="t-home-sub-banner-detail__row">
                    <div class="t-home-sub-banner-detail__col-1">
                      <div class="t-home-sub-banner-detail__fields">
                        <m-form-input>
                          <a-upload-field
                            id="t-home-sub-banner-detail-upload-image"
                            v-model="homeSubBannerData.imageFile.file"
                            test-id-text="detail-home-sub-banner-image"
                            name="imageFile"
                            class="t-home-sub-banner-detail-uploading-file__form-upload"
                            label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                            :disabled="true"
                          />
                        </m-form-input>
                      </div>
                    </div>
                    <div class="t-home-sub-banner-detail__col-2">
                      <div class="t-home-sub-banner-detail__fields">
                        <m-form-input>
                          <a-apply-text-field
                            id="title"
                            v-model="homeSubBannerData.title"
                            data-testid="detail-home-sub-banner-title-display"
                            type="text"
                            maxlength="30"
                            maxlength-id="t-home-sub-banner-detail-title-maxlength"
                            placeholder="タイトル入力"
                            :disabled="true"
                          />
                        </m-form-input>
                      </div>
                    </div>
                  </div>
                  <!-- 共通：URL入力エリア -->
                  <div class="t-home-sub-banner-detail__row">
                    <a-text id="t-home-sub-banner-detail-iOSWebsite__a-text">
                      ios側Webサイト&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-text
                    >
                    <m-form-input>
                      <a-apply-text-field
                        id="t-home-sub-banner-detail-iOS__contents-url"
                        v-model="homeSubBannerData.iosContentsURL"
                        class="t-home-sub-banner-detail__contents-url"
                        :disabled="true"
                        data-testid="t-home-sub-banner-add-url-input"
                        type="text"
                        maxlength="500"
                        maxlength-id="t-home-sub-banner-detail-iOS__contents-url-maxlength"
                        placeholder="iOS側のURL入力"
                      />
                    </m-form-input>
                  </div>
                  <div class="t-home-sub-banner-add__row">
                    <a-text id="t-home-sub-banner-detail-androidWebsite__a-text"> android側Webサイト</a-text>
                    <m-form-input>
                      <a-apply-text-field
                        id="t-home-sub-banner-detail-android__contents-url"
                        v-model="homeSubBannerData.androidContentsURL"
                        class="t-home-sub-banner-add__contents-url"
                        :disabled="true"
                        data-testid="t-home-sub-banner-add-url-input"
                        type="text"
                        maxlength="500"
                        maxlength-id="t-home-sub-banner-detail-android__contents-url-maxlength"
                        placeholder="android側のURL入力"
                      />
                    </m-form-input>
                  </div>
                </div>
              </m-action-card>
            </div>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-home-sub-banner-detail__fields">
                <div id="t-home-sub-banner-detail-cast-start-date-day__row" class="t-home-sub-banner-detail__row">
                  <a-text id="t-home-sub-banner-detail-cast-start-date__a-text">公開日</a-text>　
                  <m-form-input id="t-home-sub-banner-detail-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="homeSubBannerData.castStartDate"
                      test-id-text="detail-home-sub-banner-publish-start"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-detail__row">
                  <a-text id="t-home-sub-banner-detail-cast-end-date__a-text">公開終了日</a-text>　
                  <m-form-input id="t-home-sub-banner-detail-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="homeSubBannerData.castEndDate"
                      test-id-text="detail-home-sub-banner-publish-end"
                      :min-date="minDate"
                      mode="dateTime"
                      :disabled="true"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-home-sub-banner-detail__fields__pushtype">
                <m-form-input id="t-home-sub-banner-detail__fields__pushtype">
                  <a-select-field
                    id="t-home-sub-banner-detail__fields__pushtype__a-select-field"
                    v-model="homeSubBannerData.checkStatus"
                    data-testid="detail-home-sub-banner-check-status-select"
                    :options="checkStatusOptions"
                    :disabled="true"
                  />
                </m-form-input>
              </div>
              <!-- 情報を表示するために m-data-table を追加します 承認フロー -->
              <m-data-table
                :empty-text="dataTableEmp"
                :fit="true"
                :data="homeSubBannerData.checkHistories"
                id-text="home-sub-banner-check-histories-info-display"
              >
                <a-data-table-column
                  prop="publishedDocumentId"
                  :min-width="120"
                  :label="'公開ドキュメントID：<br>' + docId"
                  align="center"
                >
                  <template #default="scope">
                    <a-text size="medium" :center="true">公開{{ scope.index + 1 }}回目</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="draft" :min-width="100" label="下書き" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.draft.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.draft.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="checked" :min-width="100" label="チェック済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.checked.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.checked.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
                <a-data-table-column prop="approved" :min-width="100" label="承認済み" align="center">
                  <template #default="scope">
                    <a-text size="medium" :center="true">{{ scope.row.approved.userName }}</a-text>
                    <a-text size="small" :center="true">{{ scope.row.approved.updateDate }}</a-text>
                  </template>
                </a-data-table-column>
              </m-data-table>
            </m-action-card>
          </m-section>
        </div>
        <div v-if="checkIsManager()" id="t-home-sub-banner-detail-buttons">
          <div v-show="!isPublished" class="t-home-sub-banner-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-home-sub-banner-detail-detail-saveBtn"
                data-testid="detail-home-sub-banner-edit-button"
                variant="block"
                color="primary"
                :disabled="isEnded || disableButton"
                @click="handleNavigateEdit"
                >編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-home-sub-banner-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-home-sub-banner-detail-edit-return-unpublished-btn"
                data-testid="detail-home-sub-banner-edit-return-unpublished-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleEditReturnUnpublished"
                >未公開に戻す</a-button
              >
            </m-form-action-buttons>
          </div>
          <div v-show="isPublished" class="t-home-sub-banner-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-home-sub-banner-detail-edit-keep-published-btn"
                data-testid="detail-home-sub-banner-edit-keep-published-button"
                variant="block"
                color="primary"
                :disabled="disabledButton || disableButton"
                @click.stop="handleEditKeepPublished"
                >公開のまま編集</a-button
              >
            </m-form-action-buttons>
          </div>
          <div class="t-home-sub-banner-detail-buttons__button">
            <m-form-action-buttons>
              <a-button
                id="t-home-sub-banner-detail-detail-deleteBtn"
                data-testid="detail-home-sub-banner-delete-button"
                variant="block"
                color="primary"
                :disabled="disableButton"
                @click.stop="handleConfirmDelete"
                >削除</a-button
              >
            </m-form-action-buttons>
          </div>
        </div>
      </form>
    </div>

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="online-shop-bannersCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="online-shop-bannersCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="t-home-sub-banner-remove-modal-close-button"
            data-testid="detail-home-sub-banner-modal-cancel-button"
            variant="outlined"
            color="primary"
            label="いいえ"
            size="small"
            @click="handleCloseModal"
          />
          <a-button
            id="t-home-sub-banner-delete-button"
            data-testid="detail-home-sub-banner-modal-confirm-button"
            variant="block"
            color="primary"
            label="はい"
            size="small"
            @click="handleDelete"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';

export default {
  name: 't-home-sub-banner-detail',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    AUploadField,
    ACalendarField,
    AApplyTextField,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: this.$route.query.id,
      show: this.$route.query.show ?? '1',
      idName: [],
      disableButton: false,
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      activeTab: 'new',
      disabledButton: null,
      isPublished: false, //公開中かどうかのフラグ
      docId: (() => {
        const id = this.$route.query.id;
        if (id.includes('_')) {
          const lastIndex = id.lastIndexOf('_');
          return id.slice(0, lastIndex);
        }
        return id;
      })(),

      // コンテンツデータ
      homeSubBannerData: {
        title: '', // 旧タイトル用
        newTitle: '', // リニューアル後タイトル
        imageURL: '', // 画像の公開URL
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        newImageURL: '', // 新画像URL
        newImageFile: { file: null, filename: null, binary: null, size: null }, // 新画像ファイルオブジェクト
        newDescription: '', // 新説明文
        newTags: ['', '', '', '', ''], // 新タグ
        position: 0, // 位置
        castStartDate: '', // 公開開始日
        castEndDate: '', // 公開終了日
        draftFlag: false, // 下書き
        dAccountLoginFlag: false, //ビジネスｄアカウントログインフラグ
        webviewFlag: false, // Webビューフラグ
        notificationPromptFlag: false, // 通知許可フラグ
        checkStatus: '', // チェックステータス
        iosContentsURL: '', // iosコンテンツの遷移先URL
        androidContentsURL: '', // androidコンテンツの遷移先URL
        checkHistories: [
          {
            draft: {
              userName: '',
              updateDate: '',
            },
            checked: {
              userName: '',
              updateDate: '',
            },
            approved: {
              userName: '',
              updateDate: '',
            },
          },
        ],
      },
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
      isEnded: false,
      nowDate: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-home-sub-banner-detail');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.handleGetHomeSubBannerInfo(() => {
      const userRole = this.$store.state.user.authInfo;
      const checkStatus = this.homeSubBannerData.checkStatus;
      if (userRole === 'writer' && checkStatus !== 'draft') {
        this.disableButton = true;
      }
    });
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-home-sub-banner-detail-' + i;
    }
  },
  mounted() {},
  methods: {
    checkIsManager() {
      return this.$store.state.user.authInfo === 'manager';
    },
    handleGetHomeSubBannerInfo(callback) {
      const id = this.$route.query.id || this.id;
      this.nowDate = utils.currentDateTime();
      if (id) {
        this.postRequest('/home-sub-banner/get', { id })
          .then(e => {
            if (e.status === 'success' && e.data) {
              const data = e.data;
              this.homeSubBannerData.title = data?.title || '';
              this.homeSubBannerData.newTitle = data?.newTitle || '';
              this.homeSubBannerData.newDescription = data?.newDescription || '';

              // タグのデコードと5枠へのマッピング
              const rawTags = data?.newTags || [];
              this.homeSubBannerData.newTags = ['', '', '', '', ''].map((_, i) =>
                rawTags[i] || ''
              );

              // activeTabに応じて画像URLとファイルデータを設定
              this.homeSubBannerData.imageURL = data?.imageURL || '';
              (this.homeSubBannerData.imageFile = {
                file: e.data.imageURL ? e.data.imageURL : null,
              }),
                (this.homeSubBannerData.newImageURL = data?.newImageURL || '');
              (this.homeSubBannerData.newImageFile = {
                file: e.data.newImageURL ? e.data.newImageURL : null,
              }),
                (this.homeSubBannerData.castStartDate = data?.castStartDate || '');
              this.homeSubBannerData.castEndDate = data?.castEndDate || '';
              this.homeSubBannerData.draftFlag = data?.draftFlag || false;
              this.homeSubBannerData.dAccountLoginFlag = data?.dAccountLoginFlag || false;
              this.homeSubBannerData.webviewFlag = data?.webviewFlag || false;
              this.homeSubBannerData.notificationPromptFlag = data?.notificationPromptFlag || false;
              this.homeSubBannerData.iosContentsURL = decodeURI(data?.iosContentsURL) || '';
              this.homeSubBannerData.androidContentsURL = decodeURI(data?.androidContentsURL) || '';
              this.homeSubBannerData.checkStatus = data?.checkStatus || '';
              this.homeSubBannerData.checkHistories = data?.checkHistories || [];
              // 下書きとチェク済み中ではなく、公開終了日時を過ぎている場合、isEndedフラグをtrueにする
              if (this.homeSubBannerData.checkStatus === 'approved') {
                if (this.homeSubBannerData.castEndDate && this.homeSubBannerData.castEndDate < this.nowDate) {
                  this.isEnded = true;
                }
              }
              const nowDate = utils.currentDateTime();
              // 公開中の投稿か確認
              if (
                data &&
                data.checkStatus === 'approved' &&
                data.castStartDate &&
                data.castEndDate &&
                data.castStartDate <= nowDate &&
                nowDate <= data.castEndDate
              ) {
                this.isPublished = true;
              }
            } else {
              this.showErrorModal(messageContent.requireTry('小バナー取得'));
            }
            if (typeof callback === 'function') {
              callback();
            }
          })
          .catch(error => {
            console.error(error);
            this.showErrorModal(messageContent.requireTry('小バナー取得'));
          });
      }
    },
    async handleEditReturnUnpublished() {
      const data = {
        id: this.$route.query.id,
      };
      await this.postRequest('/home-sub-banner/edit-return-unpublished', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'HomeSubBanner' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('小バナー更新'));
          }
        }
      });
    },
    async handleEditKeepPublished() {
      const data = {
        id: this.$route.query.id,
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/home-sub-banner/edit-keep-published', data).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'HomeSubBanner' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('小バナー更新'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleNavigateEdit() {
      const id = this.$route.query.id;
      if (id) {
        this.$router.push({ name: 'HomeSubBannerEdit', query: { id: id, source: 'detail', show: this.show } });
      }
    },
    handleConfirmDelete() {
      this.resultModalVisible = true;
      this.resultModalTitle = 'Info';
      this.resultModalContent = messageContent.confirmDelete(this.homeSubBannerData.title);
    },
    handleDelete() {
      this.handleCloseModal();
      const data = {
        execUserID: this.$store.state.user.userID,
        documentID: this.$route.query.id,
      };
      this.postRequest('/home-sub-banner/delete', data).then(() => {
        this.$router.push({ name: 'HomeSubBanner', query: { show: this.show } });
      });
    },
    handleCancelClick() {
      this.$router.push({ name: 'HomeSubBanner', query: { show: this.show } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
